import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#0B2C4D] text-white py-12">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_bec05211-66fe-40f4-be9b-9c2beecb0c73/artifacts/bvs625is_Logogo.png" 
              alt="GoldenPort International" 
              className="h-16 w-auto mb-4"
            />
            <p className="text-lg font-semibold text-[#C9A24D] mb-3">
              Your Trusted India to Global Export Facilitation Partner
            </p>
            <p className="text-gray-300 text-sm leading-relaxed">
              GoldenPort International Pvt. Ltd. is a DPIIT-recognised Indian startup specializing in export facilitation and trade finance coordination. We help Indian manufacturers safely export their products to global markets with complete risk protection, bank-controlled payments, and end-to-end transaction management.
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-[#C9A24D]">Contact Us</h3>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#C9A24D] mt-1 flex-shrink-0" />
                <p className="text-sm text-gray-300">
                  Shop-62, Indira Nagar, Chembur Colony,<br />
                  Mumbai – 400074, Maharashtra, India
                </p>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-[#C9A24D] flex-shrink-0" />
                <div className="text-sm text-gray-300">
                  <p>8652348614 | 8928035752</p>
                  <p>7710824151</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-[#C9A24D] flex-shrink-0" />
                <a href="mailto:ssm@goldenport.in" className="text-sm text-gray-300 hover:text-[#C9A24D]">
                  ssm@goldenport.in
                </a>
              </div>
            </div>
          </div>

          {/* Legal Info */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-[#C9A24D]">Legal Information</h3>
            <div className="space-y-2 text-sm text-gray-300">
              <p><strong>CIN:</strong> U46305MH2025PTC464032</p>
              <p><strong>GST:</strong> 27AAMCG6244M1Z1</p>
              <p><strong>DPIIT No:</strong> DIPP237006</p>
            </div>
            <div className="mt-6 pt-6 border-t border-gray-700">
              <p className="text-xs text-gray-400 leading-relaxed">
                We specialize in spices, food products, and agricultural commodities export to 20+ countries worldwide including UAE, Saudi Arabia, USA, UK, and more.
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-6 text-center text-sm text-gray-400">
          <p>© {new Date().getFullYear()} GoldenPort International Pvt. Ltd. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
